import {
  SaveToolbar as SaveToolbarGeneric,
  type SaveToolbarProps as SaveToolbarPropsGeneric,
} from "@package/ui-apollo-components";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import { type SidebarEntryPath } from "../../constants/contants";

type SaveToolbarProps = SaveToolbarPropsGeneric & {
  path: SidebarEntryPath;
};

export function SaveToolbar({ path, ...props }: SaveToolbarProps) {
  const navigate = useNavigate();
  const { search } = useLocation();

  const onCanceled = useCallback(() => {
    if (props.onCanceled) {
      return props.onCanceled();
    }

    navigate(`/${path}${search}`);
  }, [navigate, path, props, search]);
  const onCreated = useCallback(
    (id?: string) => {
      if (props.onCreated) {
        return props.onCreated(id);
      }

      navigate(`/${path}${search}`);
    },
    [navigate, path, props, search],
  );
  const onDeleted = useCallback(() => {
    if (props.onDeleted) {
      return props.onDeleted();
    }

    navigate(`/${path}${search}`);
  }, [navigate, path, props, search]);

  return (
    <SaveToolbarGeneric
      {...props}
      onCanceled={onCanceled}
      onCreated={onCreated}
      onDeleted={onDeleted}
    />
  );
}
